import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { APP_ID, NgModule, inject, provideAppInitializer } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { customIconRegistryFactory } from '@app/core/factories/custom-icon-registry.factory';
import { DpStorefrontModule } from '@app-modules/storefront';
import { DpCustomStorefrontModule } from '@app-modules/custom-storefront.module';
import { DpProductsService } from '@app/core/services/products.service';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { provideConfig } from '@spartacus/core';
import { AppRoutingModule, OnNavigateConfig } from '@spartacus/storefront';
import { AppComponent } from './app.component';
import { BaseSiteInitializer } from './base-site-initializer';
import { DpUrlService } from '@app/core/services/url.service';
import { SpartacusModule } from './spartacus/spartacus.module';
import { customParameterReducer } from '@app/core/store/custom-parameter/custom-parameter.reducer';
import { DpCustomParameterEffects } from '@app/core/store/custom-parameter/custom-parameter.effects';
import { customParameterInitializer } from '@app/core/factories/custom-parameter.factory';

const providers = [
  provideHttpClient(withFetch(), withInterceptorsFromDi()),
  { provide: APP_ID, useValue: 'serverApp' },
  DpUrlService,
  DpProductsService,
  provideAppInitializer(() => {
    const initializerFn = (
      (baseSiteInitializer: BaseSiteInitializer) => () =>
        baseSiteInitializer.initialize()
    )(inject(BaseSiteInitializer));
    return initializerFn();
  }),

  provideAppInitializer(() => {
    const initializerFn = customIconRegistryFactory(inject(MatIconRegistry), inject(DomSanitizer));
    return initializerFn();
  }),
  customParameterInitializer,
  provideConfig(<OnNavigateConfig>{
    enableResetViewOnNavigate: {
      ignoreQueryString: true,
      ignoreRoutes: ['p', 'product']
    }
  })
];

const imports = [
  BrowserModule,
  AppRoutingModule,
  StoreModule.forRoot({
    customParameter: customParameterReducer
  }),
  EffectsModule.forRoot([DpCustomParameterEffects]),
  SpartacusModule,
  DpStorefrontModule,
  DpCustomStorefrontModule
];

@NgModule({
  declarations: [AppComponent],
  providers,
  imports,
  bootstrap: [AppComponent]
})
export class AppModule {}
